export enum PlatformFeeOrderType {
  Delivery = "DELIVERY",
  Pickup = "PICKUP",
  Return = "RETURN"
}
